export const deactivatedAccessCardName = 'Deactivated';
